import angular from "angular";

angular
    .module('app')
    .component('usersImport', {
        template: require('./users-import.html'),
        controller: ['Upload', '$http', controller]
    });

function controller(Upload, $http) {

    let $ctrl = this;

    $ctrl.file = null;

    $ctrl.uploadExcel = function () {
        $ctrl.parseLoading = true;
        $ctrl.users = null;
        Upload
            .upload({
                url: '/admin/users-import/parse-excel',
                data: {file: $ctrl.file},
            })
            .then(
                function (response) {
                    $ctrl.parseLoading = false;
                    $ctrl.users = response.data.users;
                    $ctrl.users.forEach(function (user) {
                        user.status = 'open';
                    });
                    checkForOpenUsers();
                    checkForDuplicatedUsers();
                },
                function (error) {
                    $ctrl.parseLoading = false;
                }
            );
    };

    function checkForDuplicatedUsers() {
        $ctrl.duplicatedPhones = [];
        for (let i = 0; i < $ctrl.users.length; i++) {
            for (let j = i + 1; j < $ctrl.users.length; j++) {
                if ($ctrl.users[i].phone === $ctrl.users[j].phone) {
                    $ctrl.duplicatedPhones.push($ctrl.users[i].phone);
                    break;
                }
            }
        }
    }

    $ctrl.cancelFile = function () {
        $ctrl.file = null;
        $ctrl.users = null;
    };

    $ctrl.delItem = function (ind) {
        $ctrl.users.splice(ind, 1);
    };

    $ctrl.loadUsers = function () {

        $ctrl.users.forEach(function (user) {
            if (user.status == 'open') {
                user.status = 'waiting';
            }
        });

        let users = $ctrl.users.filter(v => v.status == 'waiting' || v.status == 'error');

        if (!users.length) {
            return;
        }

        $ctrl.loading = true;

        loadUser(0, users);
    };

    function loadUser(ind, users) {

        let user = users[ind];

        user.status = 'loading';
        user.errorMessage = null;
        user.validationErrors = null;

        user.password = $ctrl.password;
        user.tag = $ctrl.tag;

        $http
            .post('/admin/users-import/store', user)
            .then(
                function (response) {
                    user.id = response.data.id;
                    user.status = 'loaded';
                    next();
                },
                function (error) {
                    user.status = 'error';
                    user.errorMessage = error.data.message;
                    if (error.status == 422) {
                        user.validationErrors = error.data.errors;
                    }
                    next();
                }
            );

        function next() {
            if (ind + 1 < users.length) {
                loadUser(ind + 1, users);
            } else {
                $ctrl.loading = false;
                checkForOpenUsers();
            }
        }
    }

    function checkForOpenUsers() {
        $ctrl.hasOpenUsers = false;
        for (let i = 0; i < $ctrl.users.length; i++) {
            if ($ctrl.users[i].status == 'open' || $ctrl.users[i].status == 'error') {
                $ctrl.hasOpenUsers = true;
                return;
            }
        }
    }

}
